import toast from 'react-hot-toast';

import { errorCatch } from '../shared/api/api.helpers';

export const toastError = (error: any) => {
  const message = errorCatch(error);
  toast.error(error || 'Ошибка');
  throw message;
};
